// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"a2cefb1f","509":"b5104408","676":"688f4a83"}[chunkId] + ".css";
};